import { all, call } from 'redux-saga/effects'

import analyticsSagas from './Analytics/sagas'
import generalSagas from './General/sagas'
import profileDownloadSagas from './ProfileDownload/sagas'
import profileInfoSagas from './ProfileInfo/sagas'
import redemptionsSagas from './Redemptions/sagas'
import rewardsSagas from './Rewards/sagas'
import authenticationSagas from './Authentication/sagas'
import externalSurveysSagas from './ExternalSurveys/sagas'
import tngSurveysSagas from './TngSurveys/sagas'
import transactionsSagas from './Transactions/sagas'
import shoppingRewardsSagas from './ShoppingRewards/sagas'
import profileRewardsSagas from './ProfileRewards/sagas'
import dataFootprintSagas from './DataFootprint/sagas'

export default {
  sagas: function* sagas() {
    yield all([
      call(analyticsSagas.main),
      call(generalSagas.main),
      call(profileDownloadSagas.main),
      call(profileInfoSagas),
      call(redemptionsSagas.main),
      call(rewardsSagas),
      call(authenticationSagas),
      call(transactionsSagas),
      call(externalSurveysSagas),
      call(tngSurveysSagas),
      call(shoppingRewardsSagas),
      call(profileRewardsSagas),
      call(dataFootprintSagas),
    ])
  },
}
